import dayjs, { Dayjs } from "dayjs";
import utc from 'dayjs/plugin/utc'; // Import the UTC plugin
import timezone from 'dayjs/plugin/timezone'; // Import the timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat'; // For parsing custom formats
dayjs.extend(timezone); // Extend dayjs with the timezone plugin

dayjs.extend(utc); // Extend dayjs with the UTC plugin
dayjs.extend(customParseFormat); // Extend dayjs with the custom parse format plugin


export function formatDateFromString(dateString: Dayjs): string {
  if (dateString === undefined) {
  
    return "Invalid Date";
  }
  const date = dayjs.utc(dateString).local(); // Parse the date as UTC and convert to local time

  // Get the day of the month
  const day = date.date();
  // Format the day with the appropriate suffix
  const dayWithSuffix = day + getDaySuffix(day);

  return `${dayWithSuffix} ${date.format("MMMM YYYY")}`;
}
// Helper function to get the day suffix (st, nd, rd, th)
function getDaySuffix(day: number): string {
  if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th etc.
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

export function formatDateAndTimeFromString(dateString: string): string {
  if (dateString === undefined || dateString === "") {
    return "-"
  }
  const date = dayjs.utc(dateString).local(); // Parse the date as UTC and convert to local time

  // Format the date and time using the desired format string
  const formattedDateTime = date.format("D MMM YYYY, h:mm A");

  return formattedDateTime;
}

export function formatTextType(input: string): string {
  if (typeof input != "string") {
    return "-";
  }
  if (input === "") {
    return "-";
  }
  if (input?.includes("_")) {
    // If the string contains underscores
    return input
      .split("_") // Split by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(" "); // Join with spaces
  } else {
    // If the string does not contain underscores
    return input?.charAt(0).toUpperCase() + input.slice(1).toLowerCase(); // Capitalize first letter only
  }
}


export const formatTime = (dateTimeString: string) => {
  if(!dateTimeString) return "";
  // Convert UTC to local time and format
  const localDateTime = dayjs.utc(dateTimeString).local();
  return localDateTime.format("hh:mm A");
};



export function getQueryParam(url: string, param: string): string | null {
  const urlParams = new URLSearchParams(url.split('?')[1]);
  return urlParams.get(param);
}

// Helper function to get just the date part from a timestamp
export const getDateKey = (timestamp: string) => {
  return new Date(timestamp).toDateString();
};